<template>
    <div>
        <base-form ref="baseForm"></base-form>
        <div class="btn-tool align-center">
            <Button type="ghost" @click="handleClose()" style="margin-left: 8px">{{$t('com.btn.close')}}</Button>
            <Button type="primary" v-on:click.stop="save('formCustom')">{{$t('com.btn.save')}}</Button>
        </div>
    </div>
</template>


<script>
import BaseForm from './form'

export default {
    components: { BaseForm},
    props :{
        tabelSelect:Object
    },
    data () {
        return {
        
        }
    },
    created(){
        this.initData()
 
    },
    //初始化后调用
    mounted:function(){
    },
    methods: {
        //保存
        save () {
            let self=this;
            let pse=this.$refs.baseForm.getFormData('formCustom')
            pse.then(formCustom=>{
                 self.$api.post('/fundAccount/updateFundAccount', formCustom, r => {
                    self.$utils.tips.aSuccess;
                    //刷新list页面列表
                    self.$emit('handleSubmit', "formCustom");
                    self.handleClose();
                },null,"finance")
            },reject=>{})
            // if (formCustom) {
            //     self.$api.post('authorityGroup/saveGroupRoleProgram', data, r => {
            //         self.$utils.tips.aSuccess;
            //         //刷新list页面列表
            //         self.$emit('handleSubmit', "formCustom");
            //         self.handleClose();
            //     },null,"finance")
            // } else {
            //     self.$utils.tips.validateWarning()
            // }
        },
        //关闭
        handleClose () {
            let tabItemName=this.$parent.name;
            this.$emit('handleClose', tabItemName);
        },
        //加载调用服务
        initData(){
            let self=this
            let params={
                "filter": {"id":self.tabelSelect.id}
            }
            self.$api.post('/fundAccount/selectFundAccount', params, r => {
                    let result=r.result[0]
                    let channelGroupName=result.channelGroupName
                    result.channelGroupName=channelGroupName&&channelGroupName.split(",")
                    //给表单baseForm传值
                    self.$refs.baseForm.setFormData('formCustom',result)
                },null,"finance")
        },
    
       
    }
}
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/customForm/update.vue